import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnTransactionDetailsComponent } from './btn-transaction-details.component';
import { MatIconModule } from '@angular/material/icon';
import { SystemIconModule } from '@app/transactions/components/transaction-form/system-icon/system-icon.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

@NgModule({
    declarations: [BtnTransactionDetailsComponent],
    exports: [BtnTransactionDetailsComponent],

    imports: [CommonModule, MatIconModule, SystemIconModule, MatButtonModule]
})
export class BtnTransactionDetailsModule {}
